<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title"><strong>{{ title }}</strong></h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="panel panel-default">
  <div class="panel-body">
    
    <!-- Loading Indicator -->
    @if (isLoading) {
<div class="loading-container">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    <!-- Data Table -->
    @if (!isLoading) {
<div>
      <table class="table table-striped blue">
        <tbody>
          @for (info of baseDataInfo; track $index) {
<tr>
            <td>{{ info.CODE_DESCRIPTION }}</td>
          </tr>
}
          
          <!-- Empty State -->
          @if (baseDataInfo.length === 0) {
<tr>
            <td class="text-center text-muted">No data available</td>
          </tr>
}
        </tbody>
      </table>
    </div>
}

  </div>
</div>
